import { useState, useEffect } from 'react';
import { TextField, InputLabel, FormControl, InputAdornment, Button, Typography, LinearProgress, Stack, Grid, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { NewPassword, RequestsPassword, loginWithOuth, sendMobileOtp } from '../../sevices/account'
import './style.scss'
import { ENV_CONFIG, VALIDATION_MSG, useValidation } from '../../constant';
import { isEmptyObj, removeItemFrmLocalStorage, setCurrentUser } from '../../utils/genericUtilities';
import { Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import CustomSnackBar from '../../shared/snackBar';
// import { Key, LocalConvenienceStoreOutlined } from '@mui/icons-material';
import DoneIcon from '@mui/icons-material/Done';
import { MuiOtpInput } from 'mui-one-time-password-input';
// import {  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';



// Login function 
const LoginComponent = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [errorPopupOpen, setErrorPopupOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [customMsg, setCustomMsg] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [strength, setStrength] = useState([])
  const [error, setError] = useState('')
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);


  const navigate = useNavigate();
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [phone, setPhone] = useState('');
  const [isMobileResend, setIsMobileResend] = useState(false);
  const [mobileTimer, setMobileTimer] = useState(30);
  const [phoneError, setPhoneError] = useState('');
  const numberVerified = false;

  useEffect(() => {
    let interval = 0;

    if (mobileTimer > 0 && isMobileResend) {
      interval = setInterval(() => {
        setMobileTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    if (isMobileResend && mobileTimer === 0) {
      setIsMobileResend(false)
    }
    return () => clearInterval(interval);
  }, [mobileTimer, isMobileResend]);

  const { email,
    setEmail,
    emailError,
    setEmailError,
    validateEmail,
    password,
    setPassword,
    passwordError,
    confirmPassword,
    setConfirmPassword,
    setPasswordError,
    confirmPasswordError,
    handleConfirmPasswordBlur,
    handlePasswordBlur } = useValidation();
  const queryParams = new URLSearchParams(window.location.search);
  const roles = queryParams.get('roles');
  const forget = queryParams.get('reset');
  const ResetToken = queryParams.get('data');

  // password validation function 
  const handleClickShowPassword = (field) => {
    if (field === 'password') {
      setShowPassword(!showPassword);
    } else if (field === 'confirmPassword') {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };
  // HANLDE MOUSE DOWN FUNCTION 
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  // REDIRECT TO SIGNUP PAGE 
  const Signup = () => {
    navigate(`/signup?roles=${roles}`)
  }

  // SNACKBAR FUNCTION 
  const handleSnackbarClick = (status, msgInfo) => {
    setOpenSnackbar(status);
    !isEmptyObj(msgInfo) && setCustomMsg(msgInfo);
  };

  // PHONE NUMBER VALIDATION 
  const handleChange = (fieldName) => (event) => {
    if (fieldName === 'phone') {
      const value = event.target.value;
      const sanitizedInput = value.replace(/[^0-9]/g, '').slice(0, 10);
      if (sanitizedInput.length <= 10) {
        setPhone(sanitizedInput);
      }
    }
    if (fieldName === 'otp') {
      const numericValue = event.replace(/\D/g, '');
      setOtp(numericValue);
    }
  };

  // PHONE NUMBER PATTERN VALIDATIONFUNCTION 
  const validatePhone = (phoneNum) => {
    const phonePattern = /^[0-9]{10}$/;
    if (!phonePattern.test(phoneNum)) {
      setPhoneError('Invalid phone number');
    } else {
      setPhoneError('');
    }
  };

  // POPUP FUNCTION 
  const ErrorPopup = () => {
    return (
      <Dialog open={errorPopupOpen} onClose={() => setErrorPopupOpen(false)} >
        <DialogTitle>Error</DialogTitle>
        <DialogContent>
          <DialogContentText style={{ width: error === 'User not found' && '300px' }}>
            {error ? error : 'Incorrect username or password. Please try again.'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setErrorPopupOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
    );
  };

  // HANLDE PASSWORD RESET FUNCTION API 
  const HandlePasswordReset = async () => {
    if (!email) {
      return setEmailError(VALIDATION_MSG.emailRequired);
    }
    setLoading(true);
    const body = {};
    body.email = email
    body.roles = roles
    try {
      const response = await RequestsPassword(body);
      if (response?.status === 200) {
        handleSnackbarClick(true, { type: 'success', msg: "We've emailed you a password reset link. Please check your inbox." })
        setLoading(false);

        setTimeout(() => {
          navigate("/")
        }, 3500);
      }

    } catch (pwdError) {
      setLoading(false);
      handleSnackbarClick(true, { type: 'error', msg: pwdError?.response?.data?.errors })
    }
    return null;
  }

  // EMAIL VALIDATION FUNCTION 
  const handleChangeEmail = (e) => {
    let email = e.target.value;

    if (email.length > 50) {
      email = email.slice(0, 50);
      setEmailError('Email is too long');
    } else {
      setEmailError('');
    }

    setEmail(email);

  }
  // UPDATE STRENGTH FUNCTION 
  const updateStrength = (criteriaName, condition) => {
    const isValuePresent = strength.some((item) => item?.[criteriaName] === true);
    if (!isValuePresent && condition) {
      setStrength([...strength, { [criteriaName]: true }]);
    }
  };

  // HANDLE PASSWORD CHANGE FUNCTION 
  const handleChangePassword = (e) => {
    const newPassword = e.target.value;
    updateStrength('passwordLength', newPassword.length < 6);
    updateStrength('Uppercase', /[A-Z]/.test(newPassword));
    updateStrength('Lowercase', /[a-z]/.test(newPassword));
    updateStrength('number', /\d/.test(newPassword));
    updateStrength('symbol', /[!@#$%^&*]/.test(newPassword));
    setPassword(newPassword);

    if (!newPassword) {
      setStrength([]);
    }
  }
  // HANLDE NEW PASSWORD API FUNCTION 
  const HandleNewPassword = async () => {
    if (!password) {
      return setPasswordError(VALIDATION_MSG.passwordRequired);
    }
    const body = {};
    setLoading(true);
    body.token = ResetToken
    body.password = password


    try {
      const response = await NewPassword(body)
      if (response?.status === 200) {
        setLoading(false);
        navigate(`/login?roles=${roles}`)
      }
    } catch (erros) {
      setLoading(false);
      setError(erros.response.data.message)
      setErrorPopupOpen(true);
    }
    return null;
  }

  //LOGIN API FUNCTION 
  const Onsubmit = async (event) => {

    event.preventDefault()
    // const erros = {}

    if (!email || !password) {
      setEmailError(VALIDATION_MSG.emailRequired);
      setPasswordError(VALIDATION_MSG.passwordRequired);
      return
    }
    setLoading(true);
    const requestParams = {};
    requestParams.username = email;
    requestParams.password = password;
    requestParams.client_id = ENV_CONFIG.CLIENT_ID;
    requestParams.client_secret = ENV_CONFIG.CLIENT_SECRET;
    requestParams.grant_type = "password";
    requestParams.login_type = "password";
    try {
      const response = await loginWithOuth(requestParams);
      if (response?.status === 200) {

        const date = new Date();
        const currentTime = date.getTime();

        const type = response?.data?.types;
        if (type[0] === 3) {
          handleSnackbarClick(true, { type: 'error', msg: "Invalid login" })
          removeItemFrmLocalStorage(['currentUser', 'token'])
        }
        if (roles === 'employee') {
          if (type[0] === 2) {
            const expires_in = currentTime + response?.data?.expires_in * 1000;
            setCurrentUser({ ...response?.data, expires_in });
            navigate(`/explorejobs?roles=${roles}`)
          } else {
            handleSnackbarClick(true, { type: 'error', msg: "Invalid login" })
          }

        } else {
          if (type[0] === 1) {
            const expires_in = currentTime + response?.data?.expires_in * 1000;
            setCurrentUser({ ...response?.data, expires_in });
            navigate("/dashboard");
          } else {
            handleSnackbarClick(true, { type: 'error', msg: "Invalid login" })
          }
        }
      }
    } catch (err) {
      setError(err.response.data.message)
      setErrorPopupOpen(true);
    }
    finally {
      setLoading(false);
    }
  };
  // HANLDE GOBACK FUNCTION 
  const handleGoBack = () => {
    navigate(-1);
  };


  // const otpVerify = async () => {
  //   setLoading(true);

  //   let data = {
  //     username: phone,
  //     password: otp,
  //     client_id: 'CLIENT003',
  //     client_secret: '5PY02KdOpCX5FO93jSjPa7gKsBvQF',
  //     grant_type: 'password',
  //     login_type: 'otp',
  //   };
  //   try {
  //     // Log in with OAuth
  //     const loginResponse = await loginWithOuth(data);
  //     if (loginResponse?.status === 200) {
  //       let date = new Date();
  //       let currentTime = date.getTime();
  //       let type = loginResponse?.data?.types;

  //       // if (type[0] === 3) {
  //       //   handleSnackbarClick(true, { type: 'error', msg: "Invalid login" })
  //       //   removeItemFrmLocalStorage(['currentUser', 'token'])
  //       // }
  //       if (roles === 'employee') {

  //         if (type[0] === 2) {
  //           const expires_in = currentTime + loginResponse?.data?.expires_in * 1000;
  //           setCurrentUser({ ...loginResponse?.data, expires_in });
  //           navigate(`/explorejobs?roles=${roles}`)
  //         } else {
  //           handleSnackbarClick(true, { type: 'error', msg: "Invalid login" })
  //         }

  //       }
  //       else {
  //         handleSnackbarClick(true, { type: 'error', msg: "Invalid login" })
  //       }


  //       if (loginResponse.status === 200) {
  //         const expires_in = currentTime + loginResponse?.data?.expires_in * 1000;
  //         setCurrentUser({ ...loginResponse?.data, expires_in });
  //         navigate("/explorejobs?roles=employee");
  //       }
  //     }
  //   } catch (err) {
  //     setError(err.response?.data?.message || 'Something Went Wrong');
  //     setErrorPopupOpen(true);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // OTP VERIFICATION API FUNCTION 
  const otpVerify = async (e) => {
    e.preventDefault();
    setMobileTimer(0);
    setLoading(true);
    const data = {
      username: phone,
      password: otp,
      client_id: 'CLIENT003',
      client_secret: '5PY02KdOpCX5FO93jSjPa7gKsBvQF',
      grant_type: 'password',
      login_type: 'otp',
    };


    try {
      // Log in with OAuth
      const loginResponse = await loginWithOuth(data);

      if (loginResponse?.status === 200) {
        const date = new Date();
        const currentTime = date.getTime();
        const type = loginResponse?.data?.types;

        if (type[0] === 2) {
          const expires_in = currentTime + loginResponse?.data?.expires_in * 1000;
          setCurrentUser({ ...loginResponse?.data, expires_in });
          navigate("/explorejobs?roles=employee");
        } else {
          handleSnackbarClick(true, { type: 'error', msg: "Invalid login" });
          setOtpSent(false)
        }
      } else {
        handleSnackbarClick(true, { type: 'error', msg: "Invalid login" });
        setOtpSent(false)
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Something Went Wrong');
      setErrorPopupOpen(true);
      setOtpSent(false)
    } finally {
      setLoading(false);
    }
  };

  // MOBILE OTP SEND API FUNCTION 
  const otpSend = async (e) => {
    e?.preventDefault();
    setOtp('');
    setLoading(true);
    const data = {
      "phone": `+91${phone}`
    }
    try {
      const response = await sendMobileOtp(data);
      if (response?.status === 200) {
        setLoading(false);
        setOtpSent(true)
        setIsMobileResend(true);
        setMobileTimer(30);
        if (response?.data?.message === "Failed to send OTP") {
          setOtpSent(false)
          handleSnackbarClick(true, { type: 'error', msg: "Failed to send OTP" })

        }
      }
    } catch (err) {
      setLoading(false);
      handleSnackbarClick(true, { type: 'error', msg: err?.response?.data?.errors?.message })
    }
  }

  // HANDLE PHONE VALUE FUNCTION 
  const handlePhoneChange = (e) => {
    const { value } = e.target;
    handleChange("phone")(e);
    validatePhone(value);
  };



  return (

    <div className="SinginFormRight">


      {loading && (
        <div className="SiginLoader">
          <Spin spinning />
        </div>
      )}
      <a onClick={handleGoBack} role="button" tabIndex="0">
        <img src={require('../../assets/images/Logo Blue TM.png')} className="SinginFormLogo" alt="" />
      </a>
      <div className="SinginFormTitleContainer">
        <span className="SinginFormTitle">

          {ResetToken
            ? 'Set Password'
            : forget
              ? 'Password Reset'
              : roles === 'employee'
                ? 'Welcome Back'
                : roles === 'employer'
                  ? 'Employer Sign In'
                  : 'Welcome Back'}
        </span>
        <span>{forget || ResetToken ? null : "Sign in to your account"}</span>
      </div>
      {ResetToken ? <div className="SinginFormPageContainer">
        <FormControl className="form-control">
          <InputLabel htmlFor="name-input">New Password</InputLabel>
          <Stack
            spacing={0.5}
            sx={{
              '--hue': Math.min(strength?.length * 10, 120),
            }}
          >
            <TextField
              variant="outlined"
              autoComplete="new-password"
              type={showPassword ? 'text' : 'password'}
              error={Boolean(passwordError)}
              helperText={passwordError}
              value={password}
              name='password'
              onBlur={handlePasswordBlur}
              onChange={handleChangePassword}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => handleClickShowPassword('password')}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              maxLength={10}
            />
            {password.length > 0 ? <LinearProgress variant="determinate"
              size="sm"
              value={Math.min((strength?.length * 100) / 5, 100)}
              sx={{
                bgcolor: 'background.level3',
                color: 'hsl(var(--hue) 80% 40%)',
              }}
            /> : null}
            <Typography
              level="body-xs"
              sx={{ alignSelf: 'flex-end', color: 'hsl(var(--hue) 80% 30%)' }}
            >
              {strength?.length <= 2 && password && 'Very weak'}
              {strength?.length === 3 && 'weak'}
              {strength?.length > 3 && strength?.length < 5 && 'strong'}
              {strength?.length === 5 && ' Very strong'}
            </Typography>
          </Stack>
        </FormControl>
        <FormControl className="form-control">
          <InputLabel htmlFor="name-input">Confirm Password</InputLabel>
          <TextField
            variant="outlined"
            type={showConfirmPassword ? 'text' : 'password'}
            error={Boolean(confirmPasswordError)}
            helperText={confirmPasswordError}
            onBlur={handleConfirmPasswordBlur}
            value={confirmPassword ?? ''}
            name='password'
            onChange={(e) => {
              const newValue = e.target.value;
              if (newValue.length <= 32) {
                setConfirmPassword(newValue);
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => handleClickShowPassword('confirmPassword')}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
        <Button type='submit' onClick={HandleNewPassword} variant="contained" className="SinginFormBtn">Submit</Button>

      </div> : forget ? <div className="SinginFormPageContainer">
        <FormControl className="form-control">
          <InputLabel htmlFor="name-input">Email id</InputLabel>
          <TextField
            id="name-input"
            name='email'
            variant="outlined"
            value={email}
            onBlur={validateEmail}
            error={Boolean(emailError)}
            helperText={emailError}
            onChange={handleChangeEmail}
            InputProps={{
              type: 'text',
            }}


          />
        </FormControl>

        <Button type='submit' onClick={HandlePasswordReset} variant="contained" className="SinginFormBtn">Reset</Button>
      </div> : <div className="SinginFormPageContainer">
        <form>

          {roles === 'employer' ?
            <>
              <FormControl className="form-control">
                <InputLabel htmlFor="name-input">Email id</InputLabel>
                <TextField
                  id="name-input"
                  name='email'
                  variant="outlined"
                  value={email}
                  onBlur={validateEmail}
                  error={Boolean(emailError)}
                  helperText={emailError}
                  onChange={handleChangeEmail}
                  InputProps={{
                    type: 'text',
                    maxLength: 50
                  }}
                  autoComplete="new-password"


                />

              </FormControl>
              <FormControl className="form-control">
                <InputLabel htmlFor="name-input">Password</InputLabel>
                <Stack
                  spacing={0.5}
                  sx={{
                    '--hue': Math.min(strength?.length * 10, 120),
                  }}
                >
                  <TextField
                    variant="outlined"
                    autoComplete="new-password" 
                    id="unique-password-input"
                    type={showPassword ? 'text' : 'password'}
                    error={Boolean(passwordError)}
                    helperText={passwordError}
                    value={password}
                    name="new-password"
                    onBlur={handlePasswordBlur}
                    onChange={handleChangePassword}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => handleClickShowPassword('password')}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    maxLength={10}
                  />
                </Stack>
              </FormControl>
              <a href={`/login?reset=password&roles=${roles}`}>Forgot Password ?</a>
              <Button type='submit' onClick={Onsubmit} variant="contained" className="SinginFormBtn">Sign in</Button>
              <Button type='button' onClick={Signup} variant="outlined" className="SinginFormLoginBtn">Don&apos;t have an account? Sign up here</Button>
            </>
            :
            <div>
              <FormControl className="form-control">
                <div className='create-password-page-label label-with-input'>{otpSent ? '' : 'Phone'}</div>
                <Grid item xs={12} sm={12}>
                  {numberVerified ? (
                    <TextField
                      id="phone_number"
                      className="form-control"
                      value={phone}
                      InputProps={{
                        type: 'text',
                        maxLength: 10,
                        pattern: '[0-9]*',
                        endAdornment: (
                          <InputAdornment position="end">
                            <DoneIcon className="phoneVerifyIcon" />
                          </InputAdornment>
                        ),
                      }}
                      inputlabelprops={{ shrink: true }}
                    />
                  ) : otpSent ? (
                    <div className="verifyOtpInput">
                      <MuiOtpInput
                        value={otp}
                        onChange={handleChange("otp")}
                        inputProps={{
                          inputMode: 'numeric',
                          pattern: '[0-9]*',
                        }}
                      />

                      <div className='d-flex w-100 align-center' style={{ justifyContent: 'space-between' }}>
                        {/* <Button className="phoneVerifyBtn" onClick={otpVerify}>
                      Verfiy OTP
                    </Button> */}
                        <Button
                          style={{ textTransform: "unset", float: 'right' }} variant="text"
                          disabled={isMobileResend && mobileTimer !== 0}
                          onClick={otpSend}
                        >
                          {isMobileResend && mobileTimer !== 0
                            ? `Resend OTP in ${mobileTimer} seconds`
                            : 'Resend OTP'
                          }
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <TextField
                      id="phone_number"
                      className="form-control"
                      value={phone}
                      onChange={handlePhoneChange}
                      error={Boolean(phoneError)}
                      helperText={phoneError}
                      inputProps={{
                        type: 'text',
                        maxLength: 10, // Display only last 4 digits
                        pattern: '[0-9]*',
                      }}
                    />
                  )}
                  {otpSent ?
                    <Button type='submit' variant="contained" className="SinginFormBtn" onClick={otpVerify} disabled={!otp || otp.length < 4}>  {otp.length < 4 ? 'Enter OTP' : 'Verify OTP'}</Button>
                    :
                    <>
                      <a href={`/login?reset=password&roles=${roles}`}>Forgot Password ?</a>
                      <Button type='submit' variant="contained" className="SinginFormBtn" onClick={otpSend} > Send OTP</Button>
                      <Button type='button' onClick={Signup} variant="outlined" className="SinginFormLoginBtn">Don&apos;t have an account? Sign up here</Button>
                    </>

                  }


                </Grid>

              </FormControl>
            </div>


          }
        </form>
      </div>}
      <ErrorPopup />
      {openSnackbar ? <CustomSnackBar
        openSnackbar={openSnackbar}
        snackBarMessage={customMsg?.msg}
        status={customMsg?.type}
        handleSnackbarClick={handleSnackbarClick}
      /> : null}
    </div>
  );
}

export default LoginComponent;